import { useCallback, useMemo, useState } from 'react';
import { StyleSheet } from 'react-native';
import { PRESSABLE_SIZE } from 'src/components/templates/PressableArea';
import { isWeb, isWebView } from 'src/utils/platform';
import { getDefaultHitSlop } from './utils';
export default function usePressFeedback({ touchFeedback = true, style, disabled, isInteractive, hasHref, onLayout, }) {
    const [pressActive, setPressActive] = useState(false);
    const [containerDimensions, setContainerDimensions] = useState({
        height: PRESSABLE_SIZE,
        width: PRESSABLE_SIZE,
    });
    const handleLayout = useCallback((ev) => {
        setContainerDimensions({
            height: ev.nativeEvent.layout.height,
            width: ev.nativeEvent.layout.width,
        });
    }, []);
    const hitSlop = useMemo(() => getDefaultHitSlop(containerDimensions), [containerDimensions]);
    const resolvedStyle = useMemo(() => StyleSheet.flatten([
        touchFeedback &&
            isInteractive && {
            opacity: pressActive ? 0.6 : 1,
        },
        style,
        hasHref &&
            isWeb &&
            !isWebView &&
            {
                textDecorationLine: 'none',
                color: 'inherit',
            },
    ]), [hasHref, isInteractive, pressActive, style, touchFeedback]);
    const onLayoutHandler = useCallback((ev) => {
        handleLayout(ev);
        onLayout?.(ev);
    }, [handleLayout, onLayout]);
    const pressHandlers = useMemo(() => ({
        onPressIn: () => setPressActive(true),
        onPressOut: () => setPressActive(false),
    }), []);
    return {
        hitSlop,
        resolvedStyle,
        onLayout: onLayoutHandler,
        pressHandlers,
    };
}
